import { formatDate, humanize } from "../../../utils/format.ts";

/** "enrichment_getleads" → "GetLeads": where a profile came from, as people say it. */
const SOURCE_NAMES: Record<string, string> = { getleads: "GetLeads", clay: "Clay" };

export function profileSourceLabel(source: string): string {
  const key = source.replace(/^enrichment_/, "");
  return SOURCE_NAMES[key] ?? humanize(key);
}

function parts(value: string): [number, number | null] | null {
  const match = /^(\d{4})(?:-(\d{1,2}))?/.exec(value);
  return match ? [Number(match[1]), match[2] ? Number(match[2]) : null] : null;
}

/** A profile date as precise as the source gave it: "2023" or "Apr 2023". */
export function formatProfileDate(value: string | null | undefined): string | null {
  const p = value ? parts(value) : null;
  if (!p) return null;
  const [year, month] = p;
  if (month == null) return String(year);
  return formatDate(`${year}-${String(month).padStart(2, "0")}-01T00:00:00Z`, "month");
}

/** "Apr 2023 – present · 2 yrs 6 mos", or as much of it as is known. */
export function formatPeriod(start?: string, end?: string, current?: boolean): string | null {
  const from = formatProfileDate(start);
  const to = current ? "present" : formatProfileDate(end);
  const range = from && to ? `${from} – ${to}` : from ?? to;
  if (!range) return null;
  const length = duration(start, current ? undefined : end);
  return length ? `${range} · ${length}` : range;
}

function duration(start?: string, end?: string): string | null {
  const a = start ? parts(start) : null;
  if (!a || a[1] == null) return null;
  const now = new Date();
  const b = end ? parts(end) : [now.getUTCFullYear(), now.getUTCMonth() + 1];
  if (!b || b[1] == null) return null;
  const months = (b[0] - a[0]) * 12 + (b[1] - a[1]) + 1;
  if (months <= 0) return null;
  const years = Math.floor(months / 12);
  const rest = months % 12;
  return [years && `${years} yr${years === 1 ? "" : "s"}`, rest && `${rest} mo${rest === 1 ? "" : "s"}`]
    .filter(Boolean)
    .join(" ");
}
